import axios from "axios";
import axiosInstance from "../../../../Utils/axios";
import { paginationQueryParams } from "../../../../Utils/paginationParam";
let cancelToken;

const roleURL = `api/v1/auth/role-permissions/role`;

//obtaining the paginated data
export const getRole = ({ rowsPerPage, search, sortOrder, pageNo }) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();

  return axiosInstance.get(`${roleURL}/list?${paginationQueryParams(rowsPerPage, search, sortOrder, pageNo)}`, {
    cancelToken: cancelToken.token,
  });
};

//obtaining all fiscal sessions
export const getAllRole = () => axiosInstance.get(`${roleURL}/list?ordering=-id`);

//obtaining the previous page data from paginated data
export const getPrevious = (previous) => axiosInstance.get(previous);

//obtaining the next page data from paginated data
export const getNext = (next) => axiosInstance.get(next);

//obtaining the particular page data from paginated data
export const getPageRole = ({ number, rowsPerPage, search }) =>
  axiosInstance.get(`${roleURL}/list?${paginationQueryParams(rowsPerPage, search, "", number)}`);

export const getRoleById = (id) => axiosInstance.get(`${roleURL}/retrieve/${id}`);

export const loadOptionsRolePermission = (id) =>
  axiosInstance.get(`api/v1/auth/role-permissions/permission/list?category=${id}`);

//creating function
export const createRole = (body) => axiosInstance.post(`${roleURL}/create`, body);
//updating function
export const updateRole = (id, body) => axiosInstance.patch(`${roleURL}/update/${id}`, body);

//searching function
export const handleSearch = (search, rowsPerPage) =>
  axiosInstance.get(`${roleURL}/list?offset=0&limit=${rowsPerPage}&search=${search}`);

// checking the redundant data
export const checkRedundantDataPermissionName = (e, cancelToken) =>
  axiosInstance.get(`${roleURL}/list?name=${e.target.value.trim()}`, {
    cancelToken: cancelToken.token,
  });
